import { Address } from '@global/types/types';
import { GET_SAVED_CUSTOMER_ADDRESSES_RESPONSE } from '@src/global/requests/checkout/GET_SAVED_CUSTOMER_ADDRESSES';

export const findAddressByUid = (
  { wGetSavedAddresses }: GET_SAVED_CUSTOMER_ADDRESSES_RESPONSE,
  uid: string
): Address | undefined =>
  wGetSavedAddresses.data.find(({ uid: addressUid }) => addressUid === uid);

export type AddressFieldToCompare =
  | 'gadStateOrProvince'
  | 'upaCity'
  | 'upaLine1'
  | 'upaLine2'
  | 'upaPhoneNumber'
  | 'upaPostcode'
  | 'wCountry'
  | 'wFirstName'
  | 'wLastName';

const addressFieldsToCompare: AddressFieldToCompare[] = [
  'gadStateOrProvince',
  'upaCity',
  'upaLine1',
  'upaLine2',
  'upaPhoneNumber',
  'upaPostcode',
  'wCountry',
  'wFirstName',
  'wLastName',
];

export const isAddressesEqual = (address1, address2) => {
  return addressFieldsToCompare.every((field) => {
    return address1[field] === address2[field];
  });
};
